import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { func, object, string } from "prop-types";
import { connect } from "react-redux";
import { trim } from "lodash";

import FilterInput from "../../atoms/FilterInput";

import { staticTexts } from "../../utils/Translate";
import { getAllAuthors } from "../../helper/api";

import "./authors-search-input.m.css";

const AuthorsSearchInput = ({ lang, className = "", query = {}, navigateToPage }) => {
  const [authors, setAuthors] = useState([]);
  const [authorName, setAuthorName] = useState();
  const [filteredAuthors, setFilteredAuthors] = useState([]);
  const ref = useRef(null);

  const getAuthor = (writers = []) => {
    if (writers.length) {
      return writers.find(({ id }) => Number(query["author-id"]) === id);
    }
    return {};
  };

  useEffect(() => {
    getAllAuthors()
      .then((authorList = []) => {
        const writers = authorList
          .filter(({ metadata: { "Public Author": author = "" } = {} } = {}) => author.match(/yes/gim))
          .sort((firstAuthor, secondAuthor) => String(firstAuthor.name).localeCompare(secondAuthor.name));
        setAuthors(writers);
        setAuthorName(getAuthor(writers)?.name || "");
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    !authorName && query["author-id"] && authors.length > 0 && setAuthorName(getAuthor(authors).name);
  }, [query["author-id"], authorName]);

  const onChange = (e) => {
    const { value = "" } = e.target;
    setAuthorName(value);
    if (String(value).length) {
      const regex = new RegExp(trim(value), "gim");
      const filtered = authors.filter(({ name = "" }) => name.match(regex));
      setFilteredAuthors(filtered);
    } else {
      setFilteredAuthors([]);
    }
  };

  const onClear = useCallback(() => {
    setAuthorName("");
    setFilteredAuthors([]);
    if (query["author-id"]) {
      delete query["author-id"];
      const queryString = new URLSearchParams(query).toString();
      navigateToPage(`/search?${queryString}`);
    }
  }, []);

  const authorClick = (author) => {
    setAuthorName(author.name);
    setFilteredAuthors([]);

    query["author-id"] = author.id;
    const queryString = new URLSearchParams(query).toString();
    navigateToPage(`/search?${queryString}`);
  };

  useEffect(() => {
    const outsideClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setFilteredAuthors([]);
      }
    };
    document.addEventListener("click", outsideClick);

    return () => document.removeEventListener("click", outsideClick);
  }, []);

  return (
    <div className={className} styleName="base" ref={ref}>
      <FilterInput
        type="text"
        onChange={onChange}
        isClear={true}
        isOpen={filteredAuthors.length > 0}
        placeHolder={staticTexts(lang).author}
        lang={lang}
        clearIcon={true}
        iconName="author-icon"
        styleName="author-search-input"
        onClear={onClear}
        value={authorName}
        id="author-input"
      />
      {filteredAuthors.length > 0 && (
        <div styleName="dropdown">
          <div styleName="authors">
            {filteredAuthors.map((author, index) => (
              <div styleName="author-name" key={index} onClick={() => authorClick(author)}>
                {author.name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

AuthorsSearchInput.propTypes = {
  lang: string,
  className: string,
  query: object,
  navigateToPage: func,
};

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
});

export default memo(connect(null, mapDispatchToProps)(AuthorsSearchInput));
